module.exports = __webpack_public_path__ + "static/DAApic-62791a8e5cb087d3ea8a6b4ce87b9ea1.png";